import React, { useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { getAuth } from 'firebase/auth';
import './AllUsersPage.css';

const USERS_PER_PAGE = 100;

const AllUsersPage = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();

const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/firebase-users`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

      const data = Array.isArray(response.data)
        ? response.data
        : response.data.users || [];

      setUsers(data);
      setCurrentPage(1);
    } catch (error) {
      console.error('Failed to fetch users', error);
      alert('Error loading users.');
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter(user =>
    user.email?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredUsers.length / USERS_PER_PAGE);
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * USERS_PER_PAGE,
    currentPage * USERS_PER_PAGE
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="users-container">
      <h2 className="users-heading">Registered Users</h2>

      <div className="users-controls">
        <button onClick={fetchUsers} className="btn btn-blue">
          {loading ? 'Loading...' : 'Load Users'}
        </button>

        <input
          type="text"
          placeholder="Search email..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="search-input"
        />

        {filteredUsers.length > 0 && (
          <CSVLink
            data={filteredUsers}
            filename="firebase-users.csv"
            className="btn btn-green"
          >
            Export CSV
          </CSVLink>
        )}
      </div>

      <p className="user-count">Total Users: {filteredUsers.length}</p>

      <div className="users-list-container">
        {paginatedUsers.length === 0 ? (
          <p>No users found.</p>
        ) : (
          <ul className="users-list">
            {paginatedUsers.map((user, idx) => (
              <li key={idx} className="user-item">
                {user.email}
              </li>
            ))}
          </ul>
        )}
      </div>

      {filteredUsers.length > USERS_PER_PAGE && (
        <div className="pagination-controls">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="btn btn-pagination"
          >
            Prev
          </button>

          <span className="pagination-status">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="btn btn-pagination"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default AllUsersPage;
